import { PDFWorker } from "@domain/pdf/pdfjs";

let _worker: PDFWorker | null = null;

export function getSharedPdfWorker(): PDFWorker {
    if (!_worker || _worker.destroyed) {
        _worker = new PDFWorker();
    }
    return _worker;
}
